<template>
  <v-alert v-if="errorMsg" :text="errorMsg" type="error" variant="outlined"></v-alert>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-primary weight-600 pb-4">Order Denial Follow Up</h1>
      </v-col>
    </v-row>
    <ReadOnlyBanner v-if="isMobile" />
    <v-row class="submission-status-wrapper">
      <v-col cols="12" class="lh--available-orders-container">
        <v-skeleton-loader :loading="showLoader" type="card-avatar, article">
          <SubmissionDetailCard :order="order" />
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row><br /></v-row>
    <v-row>
      <v-col v-if="order && !isMobile" cols="12">
        <v-expansion-panels :model-value="expanded">
          <v-expansion-panel value="fax" @group:selected="clearFaxSentMessage">
            <v-expansion-panel-title class="text-primary" :class="{ 'text-success': faxSentMessage }">
              {{ faxSentMessage ? faxSentMessage : "Contact the provider" }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <OutgoingFaxEditor
                :types="[TEMPLATE_TYPES.DENIAL_FOLLOW_UP]"
                :order-info="order"
                :to-fax-number="order.providerFax ?? order.providerContactFax"
                @on-complete="onFaxSent" />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row><br /></v-row>
    <v-row v-if="order">
      <v-col cols="12">
        <AuditEntryList :key="entrieskey" :order-info-id="order.orderKey" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { orderInfoService } from "@/services/orderInfoService";
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import { TEMPLATE_TYPES } from "@/models/templates";
import AuditEntryList from "@/components/AuditLogList.vue";
import SubmissionDetailCard from "@/components/SubmissionDetailCard.vue";
import OutgoingFaxEditor from "@/components/OutgoingFaxEditor.vue";
import ReadOnlyBanner from "@/components/dashboard/ReadOnlyBanner.vue";
import { useResponsive } from "@/composables/useResponsive";

const { isMobile } = useResponsive();

const showLoader = ref(true);
const errorMsg = ref("");
const order = ref(null);
const entrieskey = ref(0);
const expanded = ref([]);
const route = useRoute();
const orderId = route.params.id;
const faxSentMessage = ref("");

onMounted(async () => {
  try {
    showLoader.value = true;
    const response = await orderInfoService.getOrderDetails(orderId);
    order.value = response.orderInfo;
  } catch (e) {
    errorMsg.value = `Failed to fetch the order: ${e.message}`;
  } finally {
    showLoader.value = false;
  }
});

const onFaxSent = ({ sent }) => {
  // Unexpand the fax panel
  expanded.value = [];
  if (sent) {
    faxSentMessage.value = "Fax queued successfully";
  } else {
    faxSentMessage.value = "";
  }
};

const clearFaxSentMessage = ({ value }) => {
  if (value) {
    faxSentMessage.value = "";
  }
};
</script>

<style scoped></style>
